import { type ChangeEvent, type FC, type ReactNode } from 'react';

import { RadioGroup as MaterialRadioGroup, type RadioGroupProps } from '@mui/material';
import { RadioFormField } from '@vakantiesnl/components/src/molecules/RadioFormField';

import { useStyles } from './RadioGroup.style';

interface Props extends RadioGroupProps {
	ariaLabel: string;
	name: string;
	radios: { group: string; value: string; label: ReactNode; checked?: boolean }[];
	radioClass?: string;
	disabled?: boolean;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const RadioGroup: FC<Props> = ({
	radios,
	name,
	ariaLabel,
	className,
	radioClass,
	disabled,
	onChange,
	...rest
}) => {
	const { classes, cx } = useStyles();

	return (
		<MaterialRadioGroup aria-label={ariaLabel} name={name} className={cx(classes.radioGroup, className)} {...rest}>
			{radios.map(({ group, value, label, checked }) => (
				<label key={value} className={cx(classes.radioItem, radioClass)}>
					<RadioFormField
						onChange={onChange}
						name={`${group}-${value}`}
						key={value}
						label={label as string}
						value={value}
						checked={checked}
						disabled={disabled}
					/>
				</label>
			))}
		</MaterialRadioGroup>
	);
};
